import { useState } from "react";

interface AccordionItem {
  title: string;
  subtitle: string;
}

interface AccordionProps {
  items: AccordionItem[];
}

export default function Accordion({ items }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div>
      {items.map((data, i) => (
        <div
          key={i}
          className="border-b border-[#62636C4A] py-4 md:py-6 lg:py-[28px]"
        >
          <button
            onClick={() => toggleAccordion(i)}
            className="w-full text-left"
          >
            <h1 className="text-[20px] md:text-[28px] lg:text-[36px] font-semibold text-[#1C1C1C]">
              {data.title}
            </h1>
            <div
              className={`grid transition-all duration-300 ease-in-out ${
                openIndex === i
                  ? "grid-rows-[1fr] opacity-100"
                  : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <h2 className="text-[16px] md:text-[20px] lg:text-[24px] font-normal text-[#62636C] leading-normal mt-4">
                  {data.subtitle}
                </h2>
              </div>
            </div>
          </button>
        </div>
      ))}
    </div>
  );
}
